import { render, staticRenderFns } from "./Detective.vue?vue&type=template&id=17d762e7&scoped=true&lang=pug&"
import script from "./Detective.vue?vue&type=script&lang=js&"
export * from "./Detective.vue?vue&type=script&lang=js&"
import style0 from "./Detective.vue?vue&type=style&index=0&id=17d762e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d762e7",
  null
  
)

export default component.exports